import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'gotoUrl'
})
export class GotoUrlPipe implements PipeTransform {
    transform(value: any): any {
        if (!value) { return ''; }
        if ((value.substr(0, 1) !== '/') && (value.substr(0, 4) !== 'http')) {
            return '/' + value;
        }
        return value;
    }
}